(function () {

    a3_cabin_reports.directive('reportsPanel', reportsPanel);

    /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name reportsPanel
   * @restrict E
   * @description
   *   Implementation of reportsPanel
   *   Initialize the panels with reports.
   * @example
   *   Usage:
   *   <reports-panel flight-id="flight.id" assessment-only="false"></reports-panel>
   * @ngInject
   */
    function reportsPanel(SettingsMain, $location, $anchorScroll,enableWaterUpliftReporting, waterUpliftSupportingAcTypes,defaultCalendarDate, 
                          UserFactory, CrewRouteFactory, SaFeedbackInfoFactory, SaCrewAssessmentFactory, AircaftPositionsFactory, 
                          ASSFSyncInfoFactory, ASSFReportFactory, CrewAssessmentFactory){
        function link($scope, element, attrs) {
            //Initialize CSS classes
            $scope.togglePanel = togglePanel;
            //$scope.showCampaignsFeedback = CampaignFactory.hasPendingFeedbacks($scope.flight.FlightId);
            $scope.goToCampaignsPanel = function () {
                $location.hash('campaigns');
                $anchorScroll();
            };

            $scope.openFaAssessment = openFaAssessment;
            $scope.faFeedbacks = {
                show: false,
                status: 'Pending',
                bottomClass: '',
                textClass: 'text-gray'
            }

            $scope.openSaAssessment = openSaAssessment;
            $scope.saFeedbacks = {
                show: false,
                status: 'Pending',
                bottomClass: '',
                textClass: 'text-gray'
            }

            $scope.openASSFReport = openASSFReport;
            $scope.assfReport = {
                flightId: null,
                show: false,
                status: 'Pending',
                isRequired: false,
                bottomClass: '',
                textClass: ''
            }
            const RuleType = {
                PreviousFlightArrivedFrom: 0,
                FlightDepartsFrom: 1,
                FlightArrivesTo: 2
            };
            
            const RuleRegionCountry = {
                EU: 0,
                Schengen: 1,
                Countries: 2
            };
            const user = UserFactory.getUser();

            if (attrs.crewRoutePage != "true") {
                $scope.showReports = true;
                $scope.getBottomClass = getBottomClass;
                $scope.getTextClass = getTextClass;
                $scope.getTopClass = getTopClass;
                $scope.hasIcon = hasIcon;
                $scope.isWaterUpliftRequired = isWaterUpliftRequired;
            } else {
                $scope.showReports = false;
            }
            //FA Feedbacks


            var showFaAssessment = false;
            if(attrs.crewRoutePage != "true" && isAssessmentEnabled && $scope.flight.assessment){
                showFaAssessment = true;
            }
            
            var isAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();

            if (attrs.crewRoutePage != "true" && user.position == 'SA' && isAssessmentEnabled && $scope.flight.assessment ) {
                const faMembersAimsIdsFromRoute = CrewRouteFactory.getFACrewMembersFromRoute($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate);
                const crewAssessmentInLS = CrewAssessmentFactory.getCrewAssessmentByRouteAndDay($scope.flight.Route, $scope.flight.DutyDay, $scope.flight.FlightDate);
                const faMembersNeedFeedback = CrewAssessmentFactory.getFaMembersForFeedback(faMembersAimsIdsFromRoute, crewAssessmentInLS);
                $scope.faFeedbacks.show = true;

                if(faMembersNeedFeedback && faMembersNeedFeedback.length > 0){
                    const isSynced = CrewAssessmentFactory.hasSyncedFeedbacks($scope.flight.Route, $scope.flight.DutyDay, $scope.flight.FlightDate);
                    //Update status:
                    if(isSynced){
                        $scope.faFeedbacks.status = "Synched";
                    }else if (crewAssessmentInLS){
                        $scope.faFeedbacks.status = crewAssessmentInLS.Status;
                    }else{
                        $scope.faFeedbacks.status = "Pending";
                    }
                    //Update classes:
                    if (($scope.flight.assessment && $scope.flight.assessment.IsExist) 
                        || $scope.faFeedbacks.status == "Stored" 
                        || $scope.faFeedbacks.status == "Synched" 
                        || $scope.faFeedbacks.status == "Outdated" ) {
                        $scope.faFeedbacks.textClass = "text-green";
                    } else if ($scope.faFeedbacks.status == "Pending") {
                        $scope.faFeedbacks.textClass = "text-blue";
                    } else if ($scope.faFeedbacks.status == "Draft") {
                        $scope.faFeedbacks.textClass = "text-orange";
                    } else if ($scope.faFeedbacks.status == "Completed") {
                        $scope.faFeedbacks.textClass = "text-purple";
                    }
                }
            }

            //SA Feedbacks
            function hasMoreThanOneYearEmployment(hireDate) {
                if (!hireDate) 
                    return true;

                var today = new Date();
                var hireDate = new Date(hireDate);

                 // Set "one year ago from today"
                var oneYearAgo = new Date();
                oneYearAgo.setFullYear(today.getFullYear() - 1);

                // Return true if hired before or on one year ago
                return hireDate <= oneYearAgo;
            }
  
            if (attrs.crewRoutePage != "true" && user.position == 'FA' && hasMoreThanOneYearEmployment(user.hireDate)) {
                const saMembersAimsIdsFromRoute = CrewRouteFactory.getSACrewMembersFromRoute($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate);
                //TODO:: find the crew route by day 
                const saMembersNeedFeedback = SaFeedbackInfoFactory.getSaMembersForFeedback(saMembersAimsIdsFromRoute);

                if($scope.flight.saAssessment && saMembersNeedFeedback && saMembersNeedFeedback.length > 0){
                    $scope.saFeedbacks.show = true;
                    const isSynced = SaFeedbackInfoFactory.hasSyncedFeedbacks($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate);
                    const feedbackInLS = SaCrewAssessmentFactory.getCrewAssessmentByDutyNoAndDay($scope.flight.DutyNo, $scope.flight.DutyDay, $scope.flight.FlightDate);
                    //Update status:
                    if(isSynced){
                        $scope.saFeedbacks.status = "Synched";
                    }else if (feedbackInLS){
                        $scope.saFeedbacks.status = feedbackInLS.Status;
                    }else{
                        $scope.saFeedbacks.status = "Pending";
                    }

                    //Update classes:
                    if ($scope.saFeedbacks.status == "Stored" || $scope.saFeedbacks.status == "Synched" ) {
                        $scope.saFeedbacks.textClass = "text-green";
                    } else if ($scope.saFeedbacks.status == "Pending") {
                        $scope.saFeedbacks.textClass = "text-blue";
                    } else if ($scope.saFeedbacks.status == "Draft") {
                        $scope.saFeedbacks.textClass = "text-orange";
                    } else if ($scope.saFeedbacks.status == "Completed") {
                        $scope.saFeedbacks.textClass = "text-purple";
                    }
                }
            }
            
            //ASSF reports
            if(user.position == 'SA'){
                const assfInfo = ASSFSyncInfoFactory.getASSFInfo();
                //from Flight Info page:  $scope.flight.FlightId
                //from Route  Info page:  $scope.firstFlightId
                var flightId = null;
                if($scope.flight){
                    flightId = $scope.flight.FlightId
                }else{
                    flightId = $scope.firstFlightId;
                }
                $scope.assfReport.flightId = flightId;
                //Check if ASSF report is required
                if(assfInfo && assfInfo.ActiveVersion){
                    $scope.assfReport.show = true;
                    //Check for assf synced
                    //Get status from assf reports in LS if exists there
                    const isASSFReportSynced = assfInfo.SyncedFlightIds.includes(flightId);
                    const assfReportInLS = ASSFReportFactory.getAssfReportFromStorage(flightId);
                    //Update status:
                    if(isASSFReportSynced){
                        $scope.assfReport.status = "Synched";
                        if(assfReportInLS){
                            $scope.assfReport.isRequired = assfReportInLS.notApplicable == false ? assfReportInLS.isRequired : false;
                        } else {
                            $scope.assfReport.isRequired = false;
                        }
                     
                    }else if (assfReportInLS){
                        $scope.assfReport.status = assfReportInLS.status;
                        $scope.assfReport.isRequired = assfReportInLS.notApplicable == false ? assfReportInLS.isRequired : false;
                    }else{
                        $scope.assfReport.status = "Pending";
                        $scope.assfReport.isRequired = false; 
                        if(assfInfo.ApplicabilityRules){
                            $scope.assfReport.isRequired = checkASSFReportIsRequired($scope.flight, assfInfo.ApplicabilityRules);
                        }
                    }
                    //Update classes:
                    if($scope.assfReport.isRequired == false){
                        $scope.assfReport.textClass = "text-gray";
                    }
                    else if ($scope.assfReport.status == "Stored" || $scope.assfReport.status == "Synched" ) {
                        $scope.assfReport.textClass = "text-green";
                    } else if ($scope.assfReport.status == "Pending") {
                        $scope.assfReport.textClass = "text-blue";
                    } else if ($scope.assfReport.status == "Draft") {
                        $scope.assfReport.textClass = "text-orange";
                    } else if ($scope.assfReport.status == "Completed") {
                        $scope.assfReport.textClass = "text-purple";
                    }
                }
            }


            function openFaAssessment() {
                SettingsMain.setEditingPage(null);
                if($scope.flight){
                    $location.path("assessment/" + $scope.flight.FlightId);
                }else{
                    $location.path("assessment/" + $scope.firstFlightId);
                }
            }

            function openSaAssessment() {
                SettingsMain.setEditingPage(null);
                if($scope.flight){
                    $location.path("saAssessment/" + $scope.flight.FlightId);
                }else{
                    $location.path("saAssessment/" + $scope.firstFlightId);
                }
                
            }

            function openASSFReport() {
                if($scope.assfReport.status !== "Stored" && $scope.assfReport.status !=="Synched"){
                    SettingsMain.setEditingPage(null);
                    if($scope.flight){
                        $location.path("assfReport/" + $scope.flight.FlightId);
                    }else{
                        $location.path("assfReport/" + $scope.firstFlightId);
                    }
                }
            }

            //check if ASSF report is required
            function checkASSFReportIsRequired(flight, applicabilityRules){
                var returnValue = false;
                if(!flight || !applicabilityRules){
                    return false;
                }
                
                var loggedCrewMember = flight.crew.find(c => c.aimsId == $scope.user.aimsId);
                if(!loggedCrewMember || loggedCrewMember.isDHC){
                    return false;
                }
                const hasPreviousFlightArrivedFrom = applicabilityRules.some(rule => rule.Type === RuleType.PreviousFlightArrivedFrom);
                if(hasPreviousFlightArrivedFrom){
                    //then we need the previous flight info:
                    flight.aircraftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
                }

                returnValue = applicabilityRules.some(rule => {
                    // Extract country codes from ASSFApplicabilityRuleCountries
                    //const countryCodes = rule.ASSFApplicabilityRuleCountries?.map(c => c.Code) || [];
                    const countryCodes = (rule.ASSFApplicabilityRuleCountries && Array.isArray(rule.ASSFApplicabilityRuleCountries)) 
                    ? rule.ASSFApplicabilityRuleCountries.map(c => c.Code) 
                    : [];
                    switch (rule.Type) {
                        case RuleType.PreviousFlightArrivedFrom:
                            return (flight.aircraftPositions &&
                                ((rule.RegionCountry === RuleRegionCountry.EU && rule.IsEU === flight.aircraftPositions.PreviousEU) ||
                                (rule.RegionCountry === RuleRegionCountry.Schengen && rule.IsSchengen === flight.aircraftPositions.PreviousSchengen) ||
                                (rule.RegionCountry === RuleRegionCountry.Countries && countryCodes.includes(flight.aircraftPositions.PreviousCountryISO)))
                            )

                        case RuleType.FlightDepartsFrom:
                            return (
                                (rule.RegionCountry === RuleRegionCountry.EU && rule.IsEU === flight.DepartureEU) ||
                                (rule.RegionCountry === RuleRegionCountry.Schengen && rule.IsSchengen === flight.DepartureSchengen) ||
                                (rule.RegionCountry === RuleRegionCountry.Countries && countryCodes.includes(flight.DepartureCountryISO))
                            );
            
                        case RuleType.FlightArrivesTo:
                            return (
                                (rule.RegionCountry === RuleRegionCountry.EU && rule.IsEU === flight.ArrivalEU) ||
                                (rule.RegionCountry === RuleRegionCountry.Schengen && rule.IsSchengen === flight.ArrivalSchengen) ||
                                (rule.RegionCountry === RuleRegionCountry.Countries && countryCodes.includes(flight.ArrivalCountryISO))
                            ); 
            
                        default:
                            return false;
                    }
                });

                //update status in flight
                $scope.assfReport.isRequired = returnValue;
                if( $scope.flight.assfReport == undefined || $scope.flight.assfReport == null
                    || $scope.flight.assfReport.isRequired == undefined || $scope.flight.assfReport.isRequired == null
                    || $scope.flight.assfReport.isRequired !== returnValue)
                    {
                        ASSFReportFactory.updateFlightAssfStatus($scope.assfReport);
                    }

                return returnValue;
            }

            
            function isWaterUpliftRequired() {
                var today = new Date($scope.flight.FlightDate);
                return ((today.getDate() == 1 || today.getDate() == 15) && enableWaterUpliftReporting && waterUpliftSupportingAcTypes.includes($scope.flight.AcType))
            }

            /**
             * toggle Panel
             * @memberof reportsPanel
             * @param {number} panelId
             */
            function togglePanel(panelId) {
                $('#' + panelId).toggle();
            }

            /**
             * Return the text ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getTextClass() {
                var classname = "";
                if ($scope.flight.LineStatus === 'na')
                    classname = "text-gray";
                else if ($scope.flight.LineStatus === 'pending')
                    classname = "text-blue";
                else if ($scope.flight.LineStatus === 'pendingoverdue')
                    classname = "text-blue";
                else if (
                    ($scope.flight.LineStatus === 'draft') ||
                    ($scope.flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "text-orange";
                } else if (
                    ($scope.flight.LineStatus === 'completed') ||
                    ($scope.flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "text-purple";
                } else if (
                    ($scope.flight.LineStatus === 'stored') ||
                    ($scope.flight.LineStatus === 'storedotheruser') ||
                    ($scope.flight.LineStatus === 'stored+otheruser') ||
                    ($scope.flight.LineStatus === 'synched') ||
                    ($scope.flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "text-green";
                }
                return classname;
            }


            /**
             * Return the panel upper ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getTopClass() {
                var classname = "";
                if ($scope.flight.LineStatus === 'na')
                    classname = "border-top-gray";
                else if ($scope.flight.LineStatus === 'pending')
                    classname = "border-top-blue";
                else if ($scope.flight.LineStatus === 'pendingoverdue')
                    classname = "border-top-blue";
                else if (
                    ($scope.flight.LineStatus === 'draft') ||
                    ($scope.flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "border-top-orange";
                } else if (
                    ($scope.flight.LineStatus === 'completed') ||
                    ($scope.flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "border-top-purple";
                } else if (
                    ($scope.flight.LineStatus === 'stored') ||
                    ($scope.flight.LineStatus === 'storedotheruser') ||
                    ($scope.flight.LineStatus === 'stored+otheruser') ||
                    ($scope.flight.LineStatus === 'synched') ||
                    ($scope.flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "border-top-green";
                }
                return classname;
            }

            /**
             * Return the panel border ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getBottomClass() {
                var classname = "";
                if ($scope.flight.LineStatus === 'na')
                    classname = "border-bottom-gray";
                else if ($scope.flight.LineStatus === 'pending')
                    classname = "border-bottom-blue";
                else if ($scope.flight.LineStatus === 'pendingoverdue')
                    classname = "border-bottom-blue";
                else if (
                    ($scope.flight.LineStatus === 'draft') ||
                    ($scope.flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "border-bottom-orange";
                } else if (
                    ($scope.flight.LineStatus === 'completed') ||
                    ($scope.flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "border-bottom-purple";
                } else if (
                    ($scope.flight.LineStatus === 'stored') ||
                    ($scope.flight.LineStatus === 'storedotheruser') ||
                    ($scope.flight.LineStatus === 'stored+otheruser') ||
                    ($scope.flight.LineStatus === 'synched') ||
                    ($scope.flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "border-bottom-green";
                }
                return classname;
            }

            /**
             * If report from another user exists, show icon
             * @memberof FlightInfoCtrl
             * @returns {boolean} hasIcon
             */
            function hasIcon() {
                var hasIcon = false;
                if (
                    ($scope.flight.LineStatus === 'draftotheruser') ||
                    ($scope.flight.LineStatus === 'completedotheruser') ||
                    ($scope.flight.LineStatus === 'storedotheruser') ||
                    ($scope.flight.LineStatus === 'stored+otheruser') ||
                    ($scope.flight.LineStatus === 'synchedotheruser')
                ) {
                    hasIcon = true;
                }
                return hasIcon;
            }

        }

        return {
            restrict: 'E',
            templateUrl: "views/directives/reportsPanel.tpl.html",
            scope: true,
            terminal: true,
            link: link
        }
    }
})();